import type { QuestionnaireState } from "../../types";

export const handleSetCurrentSectionAction = (
  state: QuestionnaireState,
  payload: number,
): QuestionnaireState => {
  const isExitingEditMode = state.isEditing === true;

  // Clean up edit sections when navigating via browser back during edit mode
  const sections = isExitingEditMode
    ? state.sections.filter(section => section.displayAs !== "edit")
    : state.sections;

  const maxSectionIndex = sections.length - 1;
  const newCurrentSectionIndex = Math.max(
    0,
    Math.min(payload, maxSectionIndex),
  );

  return {
    ...state,
    sections,
    currentSectionIndex: newCurrentSectionIndex,
    lastViewedSectionIndex: Math.max(
      newCurrentSectionIndex,
      state.lastViewedSectionIndex,
    ),
    isValid: false,
    // Clear edit mode state if exiting
    ...(isExitingEditMode && {
      isEditing: false,
      errors: {},
      selectedQuestion: null,
      changedQuestions: [],
    }),
  };
};
